"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toProductTimestampIso = exports.getProductTimestampMs = exports.parseProductTimestampString = void 0;
const legacyProductTimestampPattern = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})(?:\.\d{1,3})?\s+[A-Za-z/_\s]+([+-])(\d{1,2})(?::?(\d{2}))?$/;
function parseProductTimestampString(value) {
    const legacyMatch = value.trim().match(legacyProductTimestampPattern);
    if (legacyMatch) {
        const [, date, time, sign, offsetHours, offsetMinutes = '00'] = legacyMatch;
        return new Date(`${date}T${time}${sign}${offsetHours.padStart(2, '0')}:${offsetMinutes}`);
    }
    return new Date(value);
}
exports.parseProductTimestampString = parseProductTimestampString;
function getProductTimestampMs(value) {
    var _a, _b, _c;
    if (value == null || value === '')
        return null;
    if (value instanceof Date) {
        const time = value.getTime();
        return Number.isNaN(time) ? null : time;
    }
    if (typeof value === 'number') {
        return value > 1000000000000 ? value : value * 1000;
    }
    if (typeof value === 'string') {
        const time = parseProductTimestampString(value).getTime();
        return Number.isNaN(time) ? null : time;
    }
    if (typeof value === 'object') {
        const timestamp = value;
        if (typeof timestamp.toMillis === 'function') {
            const time = timestamp.toMillis();
            return Number.isNaN(time) ? null : time;
        }
        if (typeof timestamp.toDate === 'function') {
            const time = timestamp.toDate().getTime();
            return Number.isNaN(time) ? null : time;
        }
        const seconds = (_a = timestamp.seconds) !== null && _a !== void 0 ? _a : timestamp._seconds;
        if (typeof seconds === 'number') {
            return (seconds * 1000 +
                Math.floor(((_c = (_b = timestamp.nanoseconds) !== null && _b !== void 0 ? _b : timestamp._nanoseconds) !== null && _c !== void 0 ? _c : 0) / 1000000));
        }
    }
    return null;
}
exports.getProductTimestampMs = getProductTimestampMs;
function toProductTimestampIso(value = new Date()) {
    const timestampMs = getProductTimestampMs(value);
    if (timestampMs == null) {
        throw new Error('Invalid product timestamp');
    }
    return new Date(timestampMs).toISOString();
}
exports.toProductTimestampIso = toProductTimestampIso;
